import { select } from '@ngneat/elf';
import {getAllEntitiesApply, selectManyByPredicate, UIEntitiesRef} from '@ngneat/elf-entities';
import {getAuditTemplateDetailsDataSource, getTemplatesDataSource} from './templates.requests';
import { templatesStore } from './templates.store';

export class TemplatesQuery {
  store = templatesStore;

  filters$ = this.store.pipe(select((state) => state.filters));
  sort$ = this.store.pipe(select((state) => state.sort));
  pagination$ = this.store.pipe(select((state) => state.tablePagination));

  filters = this.store.getValue().filters;

  templates$ = getTemplatesDataSource.data$();

  auditTemplateDetails$ = getAuditTemplateDetailsDataSource.data$();

  selectedTemplates$ = this.store.pipe(
    selectManyByPredicate((templatesUI) => templatesUI.selected, { pluck: 'id', ref: UIEntitiesRef }),
  );

  get totalRows() {
    return this.store.getValue().pagination.total;
  }

  get selectedTemplates() {
    return this.store.query(
        getAllEntitiesApply({
          mapEntity: (e) => e.id,
          filterEntity: (e) => e.selected,
          ref: UIEntitiesRef,
        })
    );
  }
}

export const templatesQuery = new TemplatesQuery();
